import { useEffect, useState } from "react";

export default function ClinicImage({ src, alt, fallback }) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  return (
    <div className="clinic-section__image-wrap">
      {!hasError && src && (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onError={() => setHasError(true)}
        />
      )}

      <div className="clinic-section__placeholder">{fallback}</div>
    </div>
  );
}